import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {Button} from 'shared/ui/buttons'
import styles from './styles.module.scss'

export const CookiesAccept: FC = () => {
  const [isCookiesAccepted, setIsCookiesAccepted] = useState(sessionStorage.getItem('isCookiesAccepted') === 'true')

  const onClick = () => {
    setIsCookiesAccepted(true)
    sessionStorage.setItem('isCookiesAccepted', 'true')
  }

  if (isCookiesAccepted) return <></>

  return (
    <div className={styles.cookiesAccept}>
      <div className={styles.cookiesAcceptBody}>
        <div className={styles.text}>
          By using this site you agree you're over 18 years and accept{' '}
          <Link to='/privacy-policy' className={styles.link}>
            use of cookies
          </Link>{' '}
          🍪
        </div>
        <Button
          as='button'
          styleType='transparentPrimary'
          className={styles.btn}
          onClick={onClick}
        >
          Accept
        </Button>
      </div>
    </div>
  )
}
